import { colorPalette } from "../../utils/constants";

export const customStyles = {
  toolbar: {
    color: colorPalette.black,
  },
  mainBox: {
    width: "100vw",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  innerBox: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    gap: 1,
    py: 1,
  },
  menuButton: {
    display: {
      xs: "flex",
      sm: "none",
    },
  },
  menu: {
    display: {
      xs: "block",
      md: "none",
    },
    mt: 1,
  },
  menuItem: {
    width: "100%",
    justifyContent: "flex-start",
    px: 3,
    py: 1.5,
    transition: "background-color 0.2s ease",
  },
  buttonBox: {
    display: {
      xs: "none",
      sm: "flex",
    },
  },
  button: {
    my: 2,
    display: "block",
    fontWeight: "bold",
  },
  title: {
    mt: 1,
    display: "block",
    color: colorPalette.sectionTitle,
    fontSize: 22,
    fontFamily: "'Bebas Neue', sans-serif",
  },
  pageButtonsBox: {
    display: {
      xs: "none",
      sm: "flex",
    },
  },
  pageButton: {
    mt: 1,
    display: "block",
    color: colorPalette.sectionTitle,
    fontSize: 22,
    fontFamily: "'Bebas Neue', sans-serif",
    "& .MuiButton-endIcon": {
      marginLeft: "4px",
    },
  },
  appBar: {
    background: "transparent",
  },
  menuText: {
    fontSize: 20,
    fontFamily: "'Bebas Neue', sans-serif",
    fontWeight: 500,
  },
  image: {
    borderRadius: 8,
  },
  icon: {
    color: colorPalette.sectionTitle,
  },
  servicesMenu: {
    mt: 1,
  },
  serviceMenuItem: {
    fontFamily: "'Barlow', sans-serif",
    fontSize: 14,
    py: 1,
    px: 2,
    transform: "none",
    fontWeight: 400,
    transition: "background-color 0.2s ease",
  },
};
